import React from "react";
import { MealPlanData, MealPlanResultsProps } from "types/mealPlans";

import ExportButtons from "./ExportButtons";

// Sample empty meal plan data structure for import functionality
const emptyMealPlan: MealPlanData = {
  constraints: {
    constraints: {},
  },
  mealPlanDays: [],
};

const MealPlanResults: React.FC<MealPlanResultsProps> = ({
  isLoading,
  onImportMealPlan,
}) => {
  return (
    <div className="p-4 h-full flex flex-col">
      <h3 className="text-xl font-semibold mb-4">Meal Plan Results</h3>

      {isLoading ? (
        <div className="flex-1 flex items-center justify-center">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-passio-indigo mb-4"></div>
            <p className="text-gray-600">Generating your meal plan...</p>
          </div>
        </div>
      ) : (
        <div className="flex-1 flex flex-col items-center justify-center text-center p-6">
          <div className="mb-8">
            <svg
              className="w-16 h-16 mx-auto text-gray-400 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
              ></path>
            </svg>
            <h4 className="text-lg font-medium text-gray-900 mb-2">
              No meal plan generated yet
            </h4>
            <p className="text-gray-600 mb-6">
              Fill out the form on the left and click one of the generate
              buttons to create your personalized meal plan.
            </p>

            {onImportMealPlan && (
              <div className="mt-4">
                <p className="text-gray-600 text-sm mb-2">
                  Or import a previously saved meal plan
                </p>
                <ExportButtons
                  mealPlanData={emptyMealPlan}
                  onImportMealPlan={onImportMealPlan}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MealPlanResults;
